import * as yup from "yup";
import { Schema } from "../../schema";
import { SingleValueObject } from "../base-value-object";
const AuthLogTypeTypeList = [
    "loginSuccess",
    "loginFailed",
    "logout",
    "failedAttempt",
    "refreshSuccess",
    "refreshFailed",
];
export class AuthLogType extends SingleValueObject {
    type;
    constructor(args) {
        super(args);
        this.type = args.type;
    }
    validator(args) {
        return this.validate(args, AuthLogType.schema);
    }
    equals(t) {
        return this.type === t?.type;
    }
    getValue() {
        return this.type;
    }
    toString() {
        return this.type;
    }
    static schema(required = true) {
        return Schema.required({
            type: yup
                .string()
                .oneOf([...AuthLogTypeTypeList])
                .label("認証ログ種別"),
        }, required);
    }
}
//# sourceMappingURL=auth-log-type.js.map